<template>
  <div ref="main-page">
    <!-- Top Selection Options -->
    <div class="tree-okr">
    <b-row class="mx-0 align-items-center top-search">
      <b-col cols="12" class="px-0">
        <div class="d-flex align-items-center pl-0 filter-data justify-content-end">
          <div class="okr-optionselect d-flex align-items-center">
            <div class="d-flex align-items-center list-grid">
              <div class="org-list select-option"  @click="goto('all-okrs')">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <g clip-path="url(#clip0_7716_60299)">
                    <path d="M9.5 6H20.5" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.5 12H20.5" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.5 18H20.5" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.5 6V6.01" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.5 12V12.01" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5.5 18V18.01" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_7716_60299">
                      <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="org-tree select-option" @click="goto('tree-okrs')">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                  <g clip-path="url(#clip0_7591_14363)"> <path d="M12.1693 4.99967C12.1693 4.55765 11.9937 4.13372 11.6811 3.82116C11.3686 3.5086 10.9446 3.33301 10.5026 3.33301C10.0606 3.33301 9.63665 3.5086 9.32409 3.82116C9.01153 4.13372 8.83594 4.55765 8.83594 4.99967C8.83594 5.4417 9.01153 5.86563 9.32409 6.17819C9.63665 6.49075 10.0606 6.66634 10.5026 6.66634C10.9446 6.66634 11.3686 6.49075 11.6811 6.17819C11.9937 5.86563 12.1693 5.4417 12.1693 4.99967Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.33333 11.6667C6.33333 11.2246 6.15774 10.8007 5.84518 10.4882C5.53262 10.1756 5.10869 10 4.66667 10C4.22464 10 3.80072 10.1756 3.48816 10.4882C3.17559 10.8007 3 11.2246 3 11.6667C3 12.1087 3.17559 12.5326 3.48816 12.8452C3.80072 13.1577 4.22464 13.3333 4.66667 13.3333C5.10869 13.3333 5.53262 13.1577 5.84518 12.8452C6.15774 12.5326 6.33333 12.1087 6.33333 11.6667Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M17.9974 11.6667C17.9974 11.2246 17.8218 10.8007 17.5092 10.4882C17.1967 10.1756 16.7728 10 16.3307 10C15.8887 10 15.4648 10.1756 15.1522 10.4882C14.8397 10.8007 14.6641 11.2246 14.6641 11.6667C14.6641 12.1087 14.8397 12.5326 15.1522 12.8452C15.4648 13.1577 15.8887 13.3333 16.3307 13.3333C16.7728 13.3333 17.1967 13.1577 17.5092 12.8452C17.8218 12.5326 17.9974 12.1087 17.9974 11.6667Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12.1693 14.9997C12.1693 14.5576 11.9937 14.1337 11.6811 13.8212C11.3686 13.5086 10.9446 13.333 10.5026 13.333C10.0606 13.333 9.63665 13.5086 9.32409 13.8212C9.01153 14.1337 8.83594 14.5576 8.83594 14.9997C8.83594 15.4417 9.01153 15.8656 9.32409 16.1782C9.63665 16.4907 10.0606 16.6663 10.5026 16.6663C10.9446 16.6663 11.3686 16.4907 11.6811 16.1782C11.9937 15.8656 12.1693 15.4417 12.1693 14.9997Z" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M10.5 6.66699V13.3337" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M5.76562 10.4129L9.40563 6.25293" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>  <path d="M15.2399 10.4132L11.6016 6.25488" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g>
                  <defs>
                    <clipPath id="clip0_7591_14363">
                      <rect width="20" height="20" fill="white" transform="translate(0.5)"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="company-tree select-option" @click="goto('company-tree-okrs')">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M2.5 17.5H17.5M7.5 6.66667H8.33333M7.5 10H8.33333M7.5 13.3333H8.33333M11.6667 6.66667H12.5M11.6667 10H12.5M11.6667 13.3333H12.5M4.16667 17.5V4.16667C4.16667 3.72464 4.34226 3.30072 4.65482 2.98816C4.96738 2.67559 5.39131 2.5 5.83333 2.5H14.1667C14.6087 2.5 15.0326 2.67559 15.3452 2.98816C15.6577 3.30072 15.8333 3.72464 15.8333 4.16667V17.5" stroke="#667085" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <b-dropdown :text="selectedPeriod.quarter+', '+selectedPeriod.year" class="custom-dropdown ml-1" variant="outline-secondary">
              <b-dropdown-item v-for="period in periods" @click="selectedPeriod = period">{{ period.quarter }}, {{period.year}}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
  <!-- End Top Selection Option -->
    <b-overlay :show="isloading" color="#38B22D" blur="5px" opacity="1.0" variant="transparent" rounded="sm" >
  </hr>
    <b-card class="bg-transparent no-shadow">
      <!-- Vertical Company View Tree Design in Reporting Order -->
      <div class="companyview-body okrgrid-body company-treeokr px-0 pt-0">
        <div class="companyview-tree m-0 okr-tree" id="company-tree" :style="{transform: 'scale(${zoomlevel})'}">
          <ul class="m-0 p-0 main-tree">
            <li id='company' class="before-expand">
              <b-card class="relative mb-0 company-dept company-okr"  @click.prevent.stop="openDetails(companyData['objectives'])">
                <!-- <div class="emp-pic">
                  <b-img :src="companyData['logo']" class="pro-img" fluid rounded="circle"
                    alt=""></b-img>
                </div>
                <div class="view-count d-flex align-items-center justify-content-between">
                  <b-badge variant="light"
                    class="total-employee text-secondary small d-flex align-items-center justify-content-center"><b-icon
                      person-circle icon="people" scale="1" class="mr-50"></b-icon>
                    <span>{{ companyData['employees_count'] }}</span></b-badge>
                  <b-badge variant="light"
                    class="total-employee text-secondary small d-flex align-items-center justify-content-center"><b-icon
                      person-circle icon="building" scale="1" class="mr-50"></b-icon>
                    <span>{{ companyData['departments_count'] }}</span></b-badge>
                </div>
                <div class="d-flex aign-items-center justify-content-center">
                  <div class="tree-content">
                    <div class="mb-0 my-1">
                      <div class="goal-header text-center mt-2">
                        <h5 class="mb-0 emp-name font-weight-bolder">{{ companyData['name'] }}</h5>
                      </div>
                    </div>
                  </div>
                </div> -->
                 <!-- Static New Design -->
          <div class="d-flex align-items-center justify-content-between w-100">
                  <div class="emp-logo d-flex align-items-center gap-6">
                    <div class="company-logo">
                      <b-img :src="companyData['logo']" class="pro-img" fluid rounded="circle" alt="company logo"></b-img>
                    </div>
                    <h2 class="mb-0">{{ companyData['name'] }}</h2>
                  </div>
                  <div class="progress-state okr-status">
                    <div class="circle_percent" :percent="Number(companyData['overall_percentage'])">
                      <div class="circle_inner">
                        <div class="round_per"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center objective-objtype">
                  <div class="obj-name d-flex align-ites-center">
                    <div class="quarter-data">
                      <h6 class="mb-0 text-left">No Of Objectives</h6>
                      <p class="value text-left mb-0">{{companyData['objectiveCount']}}</p>
                    </div>
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="2" height="35" viewBox="0 0 2 35" fill="none">
                    <path d="M1 1L1 34" stroke="#D0D5DD" stroke-linecap="round"/>
                  </svg>
                  <div class="obj-period d-flex align-ites-center">
                    <div class="quarter-data">
                      <h6 class="mb-0 text-left">Quarter</h6>
                      <p class="value text-left mb-0">{{this.selectedPeriod.quarter}} {{this.selectedPeriod.year}}</p>
                    </div>
                  </div>
                </div>
                <div class="w-100 overall-progress pb-50">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 class="mb-0">Overall Progress</h6>
                    <span class="ml-50">{{Number(companyData['overall_percentage'])}}%</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <b-progress :value="Number(companyData['overall_percentage'])" max="100" class="flat-progress w-100"></b-progress>
                  </div>
                </div> 
                </hr>
                <!-- Expanded List -->
                <div class="expand-list border-top pt-50 mt-50">
                  <div class="d-flex align-items-center justify-content-between list-unstyled my-25 gap-6" v-for="objective in companyData['objectives']" @click.prevent.stop="openDetails([objective])">
                    <h6 class="mb-0">{{objective.title}}</h6>
                    <div class="progress-state">
                      <div class="circle_percent" :percent="Number(objective.overall_status.percentage)">
                        <div class="circle_inner">
                          <div class="round_per"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <b-button id="root-node-arrow" class="expand-icon " v-if="rootPeople && rootPeople.length"  @click.stop="reportingListClicked('company')" >
                  <feather-icon icon="PlusIcon" size="18" class="before-expand m-0"/>
                  <feather-icon icon="MinusIcon" size="18" class="after-expand m-0" />
                </b-button>
              </b-card>
              <nodes v-if="rootPeople.length" parent="company" :parentData="null" ref="children-company" :selectedPeriod="selectedPeriod" />
            </li>
          </ul>
        </div>
      </div>
      <!-- Add Employee Form Popup -->
      <b-sidebar
        id="addemp-popover"
        ref="addemp-popover"
        bg-variant="white"
        shadow
        backdrop
        no-header
        right
        width="35%"
        title="Add New Employee"
        class="tree-emp"
        v-if="node_type && parent_name"
      >
        <template #default="{ hide }">
            <!-- Header -->
          <b-link class="text-primary floating-close" @click="hide">
          <feather-icon icon="XCircleIcon" size="26" class="mr-25" />
        </b-link>
        <div class="d-flex justify-content-between align-items-center content-sidebar-header p-2 border-bottom sticky-top">
          <h3 class="mb-0 font-weight-bold">Add New Employee</h3>
          <b-button size="sm" @click="addNode()" class="btn-primary">Save</b-button>
        </div>
          <!-- Footer -->
          <!-- BODY -->
          <b-card class="sidebar-pop">
            <b-row>
              <b-col>
                <label>Select Employees to place under "{{parent_name}}"</label>
                <v-select
                  :dir="
                    $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                  "
                  v-model="selectedEmployees"
                  :options="employeeListOptions"
                  class="w-100"
                  label="label"
                  :reduce="(val) => val.code"
                  placeholder="Select Employee"
                  input-id="select-person"
                  :clearable="false"
                  multiple
                />
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-sidebar>
      <!-- End Add Employee Form Popup -->
      <!-- Add Department Popup -->
      <b-sidebar
        id="dept-popover"
        ref="dept-popover"
        bg-variant="white"
        shadow
        backdrop
        no-header
        right
        width="35%"
        title="Add New Department"
        class="tree-emp"
        v-if="node_type && parent_name"
      >
        <template #default="{ hide }">
              <!-- Header -->
        <b-link class="text-primary floating-close" @click="hide">
          <feather-icon icon="XCircleIcon" size="26" class="mr-25" />
        </b-link>
        <div class="d-flex justify-content-between align-items-center content-sidebar-header p-2 border-bottom sticky-top">
          <h3 class="mb-0 font-weight-bold">Add New Department</h3>
          <b-button size="sm" @click="addNode()" class="btn-primary">Save</b-button>
        </div>
          <!-- Footer -->
          <!-- BODY -->
          <b-card class="sidebar-pop">
            <b-row>
              <b-col sm="12">
                <label>Enter Department Name</label>
                <b-form-input
                  id="name"
                  v-model="department_name"
                  placeholder="Department Name"
                />
              </b-col>
              <b-col sm="12" class="mt-2 ml-auto color-pick">
                <b-form-group label="Node Color" label-for="node-color">
                  <colour-picker
                  v-model="color" :color="color"/>
                </b-form-group>
              </b-col>
              <!-- <b-col sm="12" v-if="department_name">
                <div>
                  <b-button :style="{backgroundColor:dynamicColor}" >{{department_name}} <b-badge>7</b-badge></b-button>
                </div>
              </b-col> -->
              <b-col sm="12">
                <label class="mt-2 mb-1">Preview Department</label>
                <div class="company-dept sub-department m-0">
                  <button class="btn dept-btn"
                  :style="{backgroundColor:color,color:'white'}">{{department_name}} <b-badge>01</b-badge></button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-sidebar>
      <!-- End Add Department Popup -->
      <!-- Edit Department Popup -->
      <b-sidebar
        id="edit-dept-popover"
        ref="edit-dept-popover"
        bg-variant="white"
        shadow
        backdrop
        no-header
        right
        width="35%"
        title="Edit Department"
        class="tree-emp"
        v-if="node_type && parent_name && node_id"
      >
        <template #default="{ hide }">
              <!-- Header -->
        <b-link class="text-primary floating-close" @click="hide">
          <feather-icon icon="XCircleIcon" size="26" class="mr-25" />
        </b-link>
        <div class="d-flex justify-content-between align-items-center content-sidebar-header p-2 border-bottom sticky-top">
          <h3 class="mb-0 font-weight-bold">Edit Department</h3>
          <b-button size="sm" @click="updateNode()" class="btn-primary">Update</b-button>
        </div>
          <!-- Footer -->
          <!-- BODY -->
          <b-card class="sidebar-pop">
            <b-row>
              <b-col sm="12">
                <label>Select Department Name to place under"{{parent_name}}"</label>
                <b-form-input
                  id="name"
                  v-model="department_name"
                  placeholder="Department Name"
                />
              </b-col>
              <b-col sm="12" class="mt-2 ml-auto color-pick">
                <b-form-group label="Node Color" label-for="node-color">
                  <colour-picker
                  v-model="color" :color="color"/>
                </b-form-group>
              </b-col>
              <!-- <b-col sm="12" v-if="department_name">
                <div>
                  <b-button :style="{backgroundColor:dynamicColor}" >{{department_name}} <b-badge>7</b-badge></b-button>
                </div>
              </b-col> -->
              <b-col sm="12">
                <label class="mt-2 mb-1">Preview Department</label>
                <div>
                  <button class="btn dept-btn"  :style="{backgroundColor:color,color:'white'}"> <span >{{department_name}}</span> <b-badge :style="{backgroundColor:color,color:'white'}"><span>99</span></b-badge></button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-sidebar>
      <!-- End Edit Department Popup -->
      <!-- Employee Info Popup -->
      <b-sidebar id="Profile-View" ref="Profile-View" bg-variant="white" shadow backdrop no-header right width="35%"
        title="Employee Profile">
        <template>
          <!-- Header -->
          <div class="
                d-flex
                justify-content-between
                align-items-center
                content-sidebar-header
                px-2
                py-2
                border-bottom
                sticky-top
              ">
            <h3 class="mb-0 font-weight-bold">Employee Profile</h3>
            <div>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="flat-danger" class="btn-icon rounded-circle"
                @click="hideProfile()">
                <feather-icon size="20" icon="XCircleIcon" />
              </b-button>
            </div>
          </div>
          <!-- BODY -->

          <b-card :img-src="require('@/assets/images/banner/banner-1.jpg')" img-alt="Profile Cover Photo" img-top
            class="card-profile sidebar-pop">
            <div class="profile-image-wrapper ">
              <div class="profile-image p-0">
                <b-avatar size="114" variant="light" :src="require('@/assets/images/logo/dckap-logo.jpg')" />
              </div>
            </div>
            <h3>User Name</h3>
            <h6 class="text-muted">
              username@dckap.com
            </h6>
            <b-badge class="profile-badge" variant="light-primary">
              Quality Analyst
            </b-badge>
            <hr class="mb-2">

            <!-- follower projects rank -->
            <div>
              <b>Employee Details</b>
              <b-list-group class="mt-1">
                <b-list-group-item>
                  <b-row>
                    <b-col cols="4">
                      Bio :
                    </b-col>

                    <b-col cols="8">

                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item>
                  <b-row>
                    <b-col cols="4">
                      Date of Join :
                    </b-col>

                    <b-col cols="8">
                      2021-10-07
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item>
                  <b-row>
                    <b-col cols="4">
                      Employee ID :
                    </b-col>

                    <b-col cols="8">
                      DCKAPIN1000
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item>
                  <b-row>
                    <b-col cols="4">
                      Reporting Manager :
                    </b-col>

                    <b-col cols="8">
                      Mohan Natarajan
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item>
                  <b-row>
                    <b-col cols="4">
                      Zircly Role :
                    </b-col>

                    <b-col cols="8">
                      Employee
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item>
                  <b-row>
                    <b-col cols="4">
                      Division :
                    </b-col>

                    <b-col cols="8">
                      Klizer
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item>
                  <b-row>
                    <b-col cols="4">
                      Department :
                    </b-col>

                    <b-col cols="8">
                      Klizer
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item>
                  <b-row>
                    <b-col cols="4">
                      Shift :
                    </b-col>

                    <b-col cols="8">
                      India Day Shift (9:30 am - 6:30 pm)
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-card>
        </template>
      </b-sidebar>
      <!-- Employee Info Popup -->
    </b-card>
    <template #overlay>
      <div class="text-center">
        <dot-loader :loading="true" color="#38B22D" size="200px"></dot-loader>
      </div>
    </template>
    </b-overlay>
    <!-- OKR Sidebar Detailed View -->
    <b-modal id="tree-objective-parent" modal-class="okr-list-details" hide-footer v-if="selectedNodes && selectedNodes.length && selectedNodes[0]">
      <template #modal-title #modal-header="{ close }" >
        <h5 class="modal-title" v-if="selectedNodes && selectedNodes.length > 0 && selectedNodes[0]"><span>{{selectedNodes[0].user.name}}</span>’s {{selectedNodes[0].quarter}}, {{selectedNodes[0].year}} {{ selectedNodes[0].type }} OKR</h5>
        <feather-icon class="cursor-pointer floating-close" icon="XIcon" size="20"
          @click="$bvModal.hide('tree-objective-parent')" />
      </template>
      <!-- Fixed Footer Related Okr Content -->
      <ul class="m-0 p-1 tree" v-if="selectedNodes && selectedNodes.length && selectedNodes[0]">
        <li class="list-unstyled mb-75" v-for="objective in selectedNodes">
          <div class="okr-detailview position-relative">
            <div class="progress-state">
              <b-badge class="ml-auto" :variant="getStatusVariant(objective.status)"> {{ objective.status }}</b-badge>
            </div>
            <b-row class="d-flex align-items-center justify-content-between w-100 m-0 after-expand" v-b-toggle="'KeyResultsView-' + objective.hashid">
              <b-col sm="10" md="10" class="pl-0 d-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 7 14" fill="none" class="click-icon">
                  <path d="M6.66489 7.85465L1.26596 13.7558C1.19149 13.8372 1.11082 13.8983 1.02394 13.939C0.937057 13.9797 0.843972 14 0.744681 14C0.546099 14 0.37234 13.9254 0.223404 13.7762C0.0744681 13.6269 -2.49053e-08 13.4302 -3.5579e-08 13.186L-5.7638e-07 0.813953C-5.87054e-07 0.569767 0.0744675 0.373062 0.223404 0.223837C0.37234 0.0746116 0.546099 -2.38708e-08 0.74468 -3.2551e-08C0.794326 -3.47211e-08 0.968085 0.0813951 1.26596 0.244185L6.66489 6.14535C6.78901 6.28101 6.87589 6.41667 6.92553 6.55232C6.97518 6.68798 7 6.83721 7 7C7 7.16279 6.97518 7.31202 6.92553 7.44767C6.87589 7.58333 6.78901 7.71899 6.66489 7.85465Z" fill="#667085" />
                </svg>
                <h5 class="main-header mb-0 w-100 pl-50">{{objective.title}}</h5>
              </b-col>
              <b-col sm="2" md="2" class="okr-status d-flex align-items-center justify-content-md-end pr-0 py-25">
                <div class="circle_percent" :percent="Number(objective.overall_status.percentage)">
                  <div class="circle_inner">
                    <div class="round_per"></div>
                  </div>
                  <div class="circle_inbox"><span class="percent_text">{{Number(objective.overall_status.percentage)}}%</span>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-collapse :id="'KeyResultsView-' + objective.hashid" class="w-100 border-top mt-50">
                <ul class="sub-tree pl-2 pt-50">
                  <li class="list-unstyled border-0 w-100"  v-for="(key_result,k) in objective.key_results">
                    <div class="bordered-liness ">
                      <b-row class="border-bottom mx-0 pt-50 d-flex align-items-center border-0 pb-75">
                          <b-col class="align-items-center pl-0" sm="8" md="8">
                              <h5>{{key_result.result_description}}</h5>
                        </b-col>
                        <b-col sm="4" md="4" class="justify-content-md-end d-flex pr-0 text-md-right">
                          <div class="input-value">
                            <p class="mb-0" v-if="key_result.metric_type == 'Boolean'">{{ (key_result.state && key_result.state == 'Yes') ? 'Completed' : 'Incomplete' }}</p>
                            <p class="mb-0" v-if="key_result.metric_type == 'Number'">{{ key_result.progress + " / "+key_result.goal}}</p>
                            <p class="mb-0" v-if="key_result.metric_type == 'Percentage'">{{ key_result.progress + " / " + key_result.goal + "%" }}</p>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </li>
                </ul>
              </b-collapse>
          </div>
        </li>
        <!-- End Update-->
      </ul>
    </b-modal>
  </div>
</template>
<script>
import {
  BAvatar,
  BCard,
  BCardText,
  BImg,
  BLink,
  BRow,
  BCol,
  BAvatarGroup,
  VBTooltip,
  BFormTextarea,
  BButton,
  BFormGroup,
  BEmbed,
  BCarousel,
  BCarouselSlide,
  BOverlay
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { kFormatter } from "@core/utils/filter";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import QuillInput from "@/components/QuillInput.vue";
import store from "@/store";
import $ from "jquery";
import Vue from "vue";
import { bus } from "@/main.js";
import axios from "@axios";
import VueCookies from "vue-cookies";
import Nodes from "./nodes.vue";
import Subnodes from "./subnodes.vue";
import ColourPicker from "@/components/CustomColorPicker.vue";
import DotLoader from 'vue-spinner/src/DotLoader.vue'
Vue.use(VueCookies);

export default {
  components: {
    BAvatar,
    BCard,
    BCardText,
    BButton,
    BFormTextarea,
    BImg,
    BFormGroup,
    BRow,
    BLink,
    BCol,
    vSelect,
    BAvatarGroup,
    BEmbed,
    QuillInput,
    // Navbar Components
    BCarousel,
    BCarouselSlide,
    Nodes,
    ColourPicker,
    Subnodes,
    BOverlay,
    DotLoader
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      zoomlevel: 1,
      userData: this.$cookies.get('userData'),
      selectedEmployees: [],
      employeeListOptions: [],
      parent_id: null,
      node_id:null,
      parent_name: null,
      department_name: null,
      node_type : null,
      companyData: [],
      rootPeople: [],
      subnodes:[],
      color:'#38B22D',
      msg:'',
      employees_count:0,
      departments_count:0,
      isCollapsed:true,
      isloading: false,
      selectedPeriod : {quarter:this.getCurrentQuarter(),year:this.getCurrentYear()},
      periods:[],
      selectedNodes:[],
    }
  },
  created() {
    this.getTreeType();
    
    this.fetchEmployeeList();


    const periods = [];
    const currentYear = new Date().getFullYear();

    // Loop through the last 3 years, including the current year
    for (let year = currentYear; year > currentYear - 2; year--) {
      // For each year, add all four quarters to the periods array
      for (let quarter = 1; quarter <= 4; quarter++) {
        periods.push({ quarter: `Q${quarter}`, year: `${year}` });
      }
    }
    this.periods = periods;
  },
  mounted() {
    $('.companyview-tree ul').hide();
    $('.companyview-tree>ul').show();
    $('.companyview-tree ul.active').hide();
  },
  methods: {
    getStatusVariant(status){
      if(status == 'Upcoming'){
        return 'light-info';
      }else if(status == 'Not Started Yet'){
        return 'light-notyet';
      }else if(status == 'In Progress'){
        return 'light-warning';
      }else if(status == 'Completed'){
        return 'light-primary';
      }else if(status == 'Cancelled'){
        return 'light-danger';
      }else if(status == 'On Hold'){
        return 'light-dark';
      }else if(status == 'Deferred'){
        return 'light-dark';
      }else if(status == 'Submitted'){
        return 'light-dark';
      }else if(status == 'Approved'){
        return 'light-primary';
      }
      return 'light-warning';
    },
    goto(target){
      if(target == 'all-okrs'){
        return window.open("/list/all-okrs", '_blank');
      }
      if(target == 'tree-okrs'){
        return window.open("/tree-okr", '_self');
      }
      if(target == 'company-tree-okrs'){
        return window.open("/company-okr", '_blank');
      }
    },
    openDetails(nodes){
      this.selectedNodes = nodes;
      this.$bvModal.show('tree-objective-parent');
      this.$nextTick(() => {
        this.updateProgress();
      });
    },
    getCurrentYear() {
      const currentDate = new Date();
      return currentDate.getFullYear();
    },
    getCurrentQuarter() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-indexed, so add 1

      // Calculate the quarter based on the current month
      if (currentMonth >= 1 && currentMonth <= 3) {
        return "Q1";
      } else if (currentMonth >= 4 && currentMonth <= 6) {
        return "Q2";
      } else if (currentMonth >= 7 && currentMonth <= 9) {
        return "Q3";
      } else {
        return "Q4";
      }
    },
    zoomIn() {
      this.zoomlevel += 0.1;
    },
    zoomOut() {
      if (this.zoomlevel > 0.1) {
        this.zoomLevel -=0.1;
      }
    },
    resetVariables(){
        this.selectedEmployees =  [];
        this.parent_id =  null;
        this.parent_name =  null;
        this.department_name =  null;
        this.node_type  =  null;
        this.node_id = null;
        this.color = '#38B22D';
        this.showDeptAddSidebar = false;
        this.showDeptEditSidebar = false;
        this.showEmpAddSidebar = false;
        this.showEmpInfoSidebar = false;
      },
    getTreeType(){
      this.isloading = true;
      axios
      .post("companyTreeOKR/type",{

        quarter : this.selectedPeriod.quarter,
          year : this.selectedPeriod.year,
      })
        .then((response) => {
          if (response.data.success) {
            this.companyData = response.data.data;
          // if (this.companyData.tree_type == 'Reporting Order') {
          //     this.getRootPeople();
          //   }else{
          //     this.getTreeSubNode('company');
          //   }
          this.getRootPeople();
            this.$nextTick(() => {
              this.updateProgress();
            });
          } else {
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Unable to fetch Company Type",
            //     icon: "EditIcon",
            //     variant: "danger",
            //     text: response.data.message,
            //   },
            // });

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unable to fetch Company Type',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
        });
    },
    fetchEmployeeList() {
      axios
        .get("list/tree-available-employees")
        .then((response) => {
          if (response.data.success) {
            this.employeeListOptions = response.data.data;
          }else{
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Unable to fetch available employee list for tree ",
            //     icon: "EditIcon",
            //     variant: "danger",
            //     text: response.data.message,
            //   },
            // });

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unable to fetch available employee list for tree',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
            
          }
        });
    },
    getRootPeople() {
      this.isloading = true;
      axios
        .get("companyTree/rootPeople")
        .then((response) => {
          if (response.data.success) {
            this.rootPeople = response.data.data;
          } else {
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Unable to fetch Company Tree",
            //     icon: "EditIcon",
            //     variant: "danger",
            //     text: response.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unable to fetch Company Tree',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
        });
      this.isloading = false;
    },
    addNode(){
      if(this.parent_id && (this.selectedEmployees.length || this.department_name)){
        var data = {
          parent_id : this.parent_id,
          people : this.selectedEmployees,
          name : this.department_name,
          node_color : this.color,
          node_type : this.node_type
        }
       this.isloading = true;
        axios
          .post("companyTree/addNode",data)
          .then((response) => {
            if (response.data.success) {
              // this.$toast({
              //   component: ToastificationContent,
              //   props: {
              //     title: "Node added to the Chart",
              //     icon: "CheckIcon",
              //     variant: "success",
              //     text: response.data.message,
              //   },
              // });
              this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Node added to the Char',
                icon: 'CheckIcon',
                variant: 'success',
                text: response.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
              this.$refs['dept-popover'].hide();
              this.$refs['addemp-popover'].hide();
              this.fetchEmployeeList();
              this.$refs['children-' + this.parent_id].getSubNodesPeople();
                this.resetVariables();
            } else {
              // this.$toast({
              //   component: ToastificationContent,
              //   props: {
              //     title: "Unable to fetch Company Tree",
              //     icon: "EditIcon",
              //     variant: "danger",
              //     text: response.data.message,
              //   },
              // });
              this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unable to fetch Company Tree',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
            }
          });
       this.isloading = false;      
      }else{
        if(!this.parent_id){
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Parent Node is not selected properly",
          //     icon: "EditIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Parent Node is not selected properly',
                icon: 'EditIcon',
                variant: 'danger',
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"error-info ",
              hideProgressBar : true,
            });
        }
        if(!this.selectedEmployees.length && this.node_type == 'employee'){
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Employee is not selected properly",
          //     icon: "EditIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Employee is not selected properly',
                icon: 'EditIcon',
                variant: 'danger',
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"error-info ",
              hideProgressBar : true,
            });
        }
        if(!this.department_name && this.node_type == 'department'){
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Department Name is required",
          //     icon: "EditIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Department Name is required',
                icon: 'EditIcon',
                variant: 'danger',
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"error-info ",
              hideProgressBar : true,
            });
        }
      }
    },
    updateNode(){
      if(this.node_id && this.department_name){
        var data = {
          node_id : this.node_id,
          people : this.selectedEmployees,
          name : this.department_name,
          node_color : this.color,
          node_type : this.node_type
        }
        this.isloading = true;

        axios
          .post("companyTree/updateNode",data)
          .then((response) => {
            if (response.data.success) {
              // this.$toast({
              //   component: ToastificationContent,
              //   props: {
              //     title: "Node Updated",
              //     icon: "CheckIcon",
              //     variant: "success",
              //     text: response.data.message,
              //   },
              // });
              this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Node Updated',
                icon: 'CheckIcon',
                variant: 'success',
                text: response.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 successful-info",
              hideProgressBar : true,
            });
              this.$refs['edit-dept-popover'].hide();
              this.fetchEmployeeList();
              this.$refs['children-' + this.node_id].getSubNodesPeople();
                this.resetVariables();
            } else {
              // this.$toast({
              //   component: ToastificationContent,
              //   props: {
              //     title: "Unable to fetch Company Tree",
              //     icon: "EditIcon",
              //     variant: "danger",
              //     text: response.data.message,
              //   },
              // });
              this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unable to fetch Company Tree',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
            }
          });
        this.isloading = false;
      }else{
        if(!this.node_id){
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Node is not selected properly",
          //     icon: "EditIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Node is not selected properly`,
              icon:'EditIcon',
              variant : 'danger',
              hideClose: true,
              
            },
                },
                {
            timeout : 3000,
            position : 'bottom-center',
            toastClassName:"error-info",
            hideProgressBar : true,
                })
        }
        if(!this.department_name && this.node_type == 'department'){
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Department Name is required",
          //     icon: "EditIcon",
          //     variant: "danger",
          //   },
          // });
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Department Name is required`,
              icon:'EditIcon',
              variant : 'danger',
              hideClose: true,
              
            },
                },
                {
            timeout : 3000,
            position : 'bottom-center',
            toastClassName:"error-info",
            hideProgressBar : true,
                })
        }
      }
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async reportingListClicked(id){
      this.isloading = true;
      // await this.sleep(2000);
      var nodeId = '#'+id;
        $("#root-node-arrow").toggleClass("activenode");
        $(nodeId).addClass("open-tree"); 
        $(nodeId).siblings('li').removeClass('open-tree');
        $(nodeId).siblings('li').find('nodes').hide();
        var children = $(nodeId).find('>div>ul');
        if (children.is(":visible")) {
          children.hide('fast').removeClass('active');
        }
        else {
          children.show('fast').addClass('active');
          this.$refs['children-'+id].getSubNodesPeople();
        }
        const element = document.getElementById(id);
        if (element) {
          element.classList.toggle("after-expand");
          element.classList.toggle("before-expand"); // Replaces any existing class with "new-class"
        }
        this.isloading = false;      
    },
    async listClicked(id) {
      this.isloading = true;
      // await this.sleep(2000);
      var nodeId = '#' + id;
      $("#root-node-arrow").toggleClass("activenode");
      $(nodeId).addClass("open-tree");
      $(nodeId).siblings('li').removeClass('open-tree');
      $(nodeId).siblings('li').find('nodes').hide();
      var children = $(nodeId).find('>div>ul');
      if (children.is(":visible")) {
        children.hide('fast').removeClass('active');
      }
      else {
        children.show('fast').addClass('active');
        try{
          this.$refs['children-' + id].getSubNodesPeople();
        }
        catch{
          this.$refs['children-' + id][0].getSubNodesPeople();
        }
      }
      this.isloading = false;
    },
    getTreeSubNode(parent_id='company'){
      this.isloading = true;
      axios
        .get("companyTree/treeSubNode/"+parent_id)
        .then((response) => {
          if (response.data.success) {
            this.subnodes = response.data.subnodes;
            this.employees_count = response.data.employees_count;
            this.departments_count = response.data.departments_count;
            var nodeId = '#company';
            $("#root-node-arrow").toggleClass("activenode");
            $(nodeId).addClass("open-tree");
            $(nodeId).siblings('li').removeClass('open-tree');
            $(nodeId).siblings('li').find('nodes').hide();
            var children = $(nodeId).find('>ul');
            if (children.is(":visible")) {
              children.hide('fast').removeClass('active');
            }
            else {
              children.show('fast').addClass('active');
            }
          } else {
            // this.$toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: "Unable to fetch Company Tree",
            //     icon: "EditIcon",
            //     variant: "danger",
            //     text: response.data.message,
            //   },
            // });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Unable to fetch Company Tree',
                icon: 'EditIcon',
                variant: 'danger',
                text: response.data.message,
              },
            }, {
              timeout: 2000, 
              position: 'bottom-center',
              toastClassName:"radius-8 error-info ",
              hideProgressBar : true,
            });
          }
        });
      this.isloading = false;    
    },
    updateProgress(){
      // Circle Progress bar Design
      $(".circle_percent").each(function() {
        var $this = $(this),
        $dataV = $this.attr('percent'),
        $dataDeg = $dataV * 3.6,
        $round = $this.find(".round_per");
        $round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");
        $this.append('<div class="circle_inbox"><span class="percent_text"></span></div>');
        $this.prop('Counter', 0).animate({Counter: $dataV},
        {
          duration: 2000, 
          easing: 'swing', 
          step: function (now) {
                  $this.find(".percent_text").text(Math.ceil(now)+"%");
              }
          });
        if($dataV >= 51){
          $round.css("transform", "rotate(" + 360 + "deg)");
          setTimeout(function(){
            $this.addClass("percent_more");
          },1000);
          setTimeout(function(){
            $round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");
          },1000);
        } 
      });
    },
    goto(target){
      if(target == 'all-okrs'){
        return window.open("/list/all-okrs", '_blank');
      }
      if(target == 'tree-okrs'){
        return window.open("/tree-okr", '_blank');
      }
      if(target == 'company-tree-okrs'){
        return window.open("/company-okr", '_self');
      }
    },
    expand(){
      var nodeId = '#org-tree';
      $('.okr-tree ul').show();
      $('.okr-tree>ul').show();
      $('.okr-tree ul.active').show();
      this.isCollapsed = false;
    },
    collapse(){
      $('.okr-tree ul').hide();
      $('.okr-tree>ul').show();
      $('.okr-tree ul.active').hide();
      this.isCollapsed = true;
    },
  },
  computed: {
    dynamicColor() {
      return this.color;
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.content-wrapper.h-100 {
  position: relative;
}
</style>